import connection from '@/api/connection'

export const getSites = async ({ commit }) => {
  let url = `/sites/selectable`;

  await connection.get(url)
    .then(res => {
      const sites = res.data.data;
      commit('setSitesSelectable', sites);
    }).catch(err => {
      console.log('error', err);
    });
}

export const siteById = async ({ commit }, id) => {
  commit('setSiteIsLoading', true);
  await connection.get(`/sites/${id}`)
    .then(res => {
      commit('setSiteDetail', res.data.data);
      commit('setSiteIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setSiteIsLoading', false);
    });
}

export const storeMultiSites = async ({ commit }, site) => {
  commit('setSiteIsCreating', true);
  await connection.post(`/sites/create/multiple`, site)
    .then(res => {
      commit('saveNewSites', res.data);
      commit('setSiteIsCreating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setSiteIsCreating', false);
    });
}

export const storeSite = async ({ commit }, site) => {
  commit('setSiteIsCreating', true);
  await connection.post(`/sites/create`, site)
    .then(res => {
      commit('saveNewSite', res.data);
      commit('setSiteIsCreating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setSiteIsCreating', false);
    });
}

export const updateSite = async ({ commit }, site ) => {
  commit('setSiteIsUpdating', true);
  await connection.put(`/sites/${site.id}/update`, site)
    .then(res => {
      commit('saveUpdatedSite', res.data);
      commit('setSiteIsUpdating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setSiteIsUpdating', false);
    });
}

export const deleteSite = async ({ commit }, site) => {
  commit('setSiteIsDeleting', true);
  await connection.delete(`/sites/${site.id}/delete`)
    .then(res => {
      commit('setDeleteSite', res.data);
      commit('setSiteIsDeleting', false);
    }).catch(err => {
      console.log('error', err);
      commit('setSiteIsDeleting', false);
    });
}
